import Vue from "vue";
let currentRequest = 0;

const AgreementService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("agreement", id, {
        include:
          "customer,services,tenant,agreementServices,invoice_periods,invoices"
      });
      return data.data[0];
    } catch (error) {
      console.log("fetchOne error: ", error);
      return { error: error };
    }
  },
  async fetchAll(searchFilterPagination) {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START AGREEMENT `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll(
        "agreements",
        searchFilterPagination
      );
      if (request !== currentRequest) {
        console.log(`[${request}] AGREEMENT DISCARDED`);
        return null;
      }
      console.log(`[${request}] END AGREEMENT `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  },
  async createOrUpdate(payload) {
    try {
      if (payload.id == "" || payload.id == null || "renewal" in payload) {
        return await Vue.$jsonApi.create("agreement", payload);
      } else {
        return await Vue.$jsonApi.update("agreement", payload);
      }
    } catch (error) {
      console.log("createOrUpdate error: ", error);
      return { error: error };
    }
  },
  async delete(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.destroy("agreement", id);
      return data;
    } catch (error) {
      console.log("delete error: ", error);
      return { error: error };
    }
  }
};

export { AgreementService };
